module.exports = __webpack_public_path__ + "img/joao.03a3d57f.webp";